const DoneDot = props => (
  <svg
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={10.5} cy={10.5} r={10.5} fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 19C12.7543 19 14.9163 18.1045 16.5104 16.5104C18.1045 14.9163 19 12.7543 19 10.5C19 8.24566 18.1045 6.08365 16.5104 4.48959C14.9163 2.89553 12.7543 2 10.5 2C8.24566 2 6.08365 2.89553 4.48959 4.48959C2.89553 6.08365 2 8.24566 2 10.5C2 12.7543 2.89553 14.9163 4.48959 16.5104C6.08365 18.1045 8.24566 19 10.5 19ZM14.4387 9.12619C14.6322 8.9258 14.7393 8.65741 14.7369 8.37882C14.7345 8.10024 14.6227 7.83375 14.4257 7.63676C14.2287 7.43976 13.9623 7.32802 13.6837 7.3256C13.4051 7.32318 13.1367 7.43027 12.9363 7.62381L9.4375 11.1226L8.06369 9.74881C7.8633 9.55527 7.59491 9.44818 7.31632 9.4506C7.03774 9.45302 6.77125 9.56476 6.57426 9.76176C6.37726 9.95875 6.26552 10.2252 6.2631 10.5038C6.26068 10.7824 6.36777 11.0508 6.56131 11.2512L8.68631 13.3762C8.88556 13.5754 9.15576 13.6873 9.4375 13.6873C9.71924 13.6873 9.98944 13.5754 10.1887 13.3762L14.4387 9.12619Z"
      fill="#66BB6A"
    />
  </svg>
)

export default DoneDot
